var unknownValue = function(value, defaultValue) {
    return value || defaultValue || '<span class="unknown-value">Unknown</span>';
};

var emptyStringToNull = function(value) {
    return value === '' ? null : value;
};

var toNumber = function(value) {
    if (value) {
        return parseInt(value);
    } else {
        return null;
    }
};

module.exports = {
    unknownValue: unknownValue,
    emptyStringToNull: emptyStringToNull,
    toNumber: toNumber,
};
